module.exports = __webpack_public_path__ + "fonts/Manrope-ExtraBold.5167c303.ttf";